module.exports = __webpack_public_path__ + "1acfc7d9f03c829bee52a53019392dfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/logo_inverted.svg
// module id = 514
// module chunks = 0